// extracted by mini-css-extract-plugin
export default {"wrapper":"j2-z","play":"k2-z"};